<template>
  <div class="preCheckAnalysis">
    <div class="management-search">
      <div class="management-search-1">
        渠道：
        <a-select
          v-model="channelList"
          placeholder="请选择渠道"
          class="select-tag"
          allowClear
          mode="multiple"
        >
          <a-select-option
            v-for="(item, index) in channelSelectList"
            :key="item.id"
            :value="item.name"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </div>
      <div class="management-search-1">
        创建日期：
        <a-date-picker
          format="YYYY-MM-DD"
          v-model="startDate"
          placeholder="开始时间"
        />
        <i style="display: inline-block; margin-left: 20px"></i>
        <a-date-picker
          format="YYYY-MM-DD"
          placeholder="结束时间"
          v-model="endDate"
        />
      </div>
    </div>
    <div class="projectList-search-button">
      <a-button type="primary" @click="query(1)">查询</a-button>
    </div>
    <a-table
      :columns="tableColumns"
      :dataSource="tableDataSource"
      :pagination="false"
      :loading="loadingTable"
      size="middle"
      :rowKey="(record) => record.id"
    >
      <span slot="preCheckFailReasonMap" slot-scope="text, record">
        <template v-if="text">
          <template v-for="(value, key, index) in text">
            <span>{{ key }}:{{ value }}</span
            ><span
              v-if="index !== Object.keys(text).length - 1"
              style="color: grey"
            >
              ｜
            </span>
          </template>
        </template>
      </span>
    </a-table>
  </div>
</template>
<script>
import api from "../lib/preCheckAnalysis.js";
import moment from "moment";

export default {
  name: "preCheckAnalysis",
  data() {
    return {
      platformParamId: undefined,
      pageNo: 1,
      tableColumns: [
        {
          title: "平台",
          dataIndex: "platform",
          align: "center",
        },
        {
          title: "前筛通过",
          dataIndex: "preCheckSuccessCount",
        },
        {
          title: "前筛未通过",
          dataIndex: "preCheckFailCount",
        },
        {
          title: "前筛未通过原因",
          dataIndex: "preCheckFailReasonMap",
          scopedSlots: { customRender: "preCheckFailReasonMap" },
        },
      ],
      tableDataSource: [],
      loadingTable: false,
      startDate: null,
      endDate: null,
      channelList: [],
      channelSelectList: [],
    };
  },
  computed: {
    preCheckFailReasonMapShow: () => {
      return (preCheckFailReasonMap) => {
        if (preCheckFailReasonMap) {
          if (JSON.stringify(preCheckFailReasonMap) == "{}") {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      };
    },
    lastLoginDateEndTime() {
      // 开始时间
      if (this.endDate) {
        return this.$common.dayFormat(this.endDate) + " " + "23:59:59";
      }
      return "";
    },
    lastLoginDateStartTime() {
      // 结束时间
      if (this.startDate) {
        return this.$common.dayFormat(this.startDate) + " " + "00:00:00";
      }
      return "";
    },
  },
  mounted() {
    this.today();
    this.query(1);
    this.getChannelList();
  },
  methods: {
    today() {
      let startTime = new Date();
      let endTime = new Date();
      this.startDate = moment(startTime, "YYYY-MM-DD");
      this.endDate = moment(endTime, "YYYY-MM-DD");
    },
    getChannelList() {
      api.channelList().then((res) => {
        if (res.result == 200) {
          this.channelSelectList.splice(0);
          res.data.forEach((element, index) => {
            this.channelSelectList.push({ id: index + 1, name: element });
          });
        }
      });
    },
    // 点击查询
    query(index) {
      if (index) {
        this.pageNo = index;
      }
      let data = {
        channelList: this.channelList,
        gmtCreatedStart: this.lastLoginDateStartTime,
        gmtCreatedEnd: this.lastLoginDateEndTime,
      };
      this.queryPage(data);
    },
    // 查询列表
    queryPage(data) {
      this.loadingTable = true;
      api
        .queryPage(data)
        .then((res) => {
          this.loadingTable = false;
          if (res.result === 200) {
            let list = res.data;
            this.tableDataSource = list;
          }
        })
        .catch((err) => {
          this.loadingTable = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.preCheckAnalysis {
  .management-search {
    position: relative;
    overflow: hidden;
    .management-search-1 {
      float: left;
      margin-right: 20px;
      margin-bottom: 20px;
    }
    .backup {
      padding: 5px 0;
    }
    span {
      width: 240px;
    }
    input {
      width: 240px;
    }
    .ant-select {
      width: 240px;
    }
  }
  .projectList-search-button {
    margin-bottom: 20px;
    button {
      margin-right: 20px;
    }
    .request_nav_item {
      display: inline-block;
      margin-right: 20px;
      width: 350px;
      input {
        width: 250px;
      }
      .ant-select {
        width: 250px;
      }
    }
  }
}
</style>